import RestAPI from "./RestAPI/RestAPI";

const APIClient = {
  //...SoapAPI todo
  ...RestAPI,
};

export default APIClient;
